<div class="modal-dialog" *ngIf="ready">

  <div class="modal-content">
    <button
      type="button"
      class="btn-close"
      data-dismiss="modal"
      play-audio
      onEnterSound="btn_close_enter"
      onClickSound="btn_close_click"
    >
      &times;
    </button>

    <div class="image-dialog">

      <div class="swiper-container" id="dialog-gallery-swiper">

        <swiper [config]="largeSwiperConfig">
          <ng-template swiperSlide *ngFor="let image of images">
            <div class="media-viewport">
              <div class="media-item">
                <slider-dialog-image [image]="image" (imageZoomed)="onImageZoomed($event)"></slider-dialog-image>
              </div>
            </div>
          </ng-template>

          <div class="navigation" slot="container-start">
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>

        </swiper>

      </div>

    </div>
  </div>
</div>
